module.exports = __webpack_public_path__ + "static/progetto_martinetti14-4abdea3e9e19179f729befe91701edca.jpg";